module.exports = __webpack_public_path__ + "static/media/templates.c9c73b0e.svg";